import {Component, Directive, ElementRef, Input, OnInit} from '@angular/core';
import { FSSLocationData, OperationLocationData } from "../../../../global/smartpower-types";

@Component({
    selector: 'performance-detail-table',
    templateUrl: './performance-detail-table.component.html',
    styleUrls: ['./performance-detail-table.component.scss'],
    standalone: false
})
export class PerformanceDetailTableComponent implements OnInit {

  @Input() tableHeader = '';
  @Input() columns: string[] = [];
  @Input() operationLocationData: OperationLocationData[] = [];
  @Input() fssLocationData: FSSLocationData[] = [];
  @Input() displayLoader = false;

  type = '';

  constructor() {}

  ngOnInit(): void {}
}

@Directive({
    selector: '[operations]',
    standalone: false
})
export class OperationDirective {
  constructor(private component: PerformanceDetailTableComponent) {
    this.component.type = 'operations';
  }
}

@Directive({
    selector: '[fss]',
    standalone: false
})
export class FssDirective {
  constructor(private component: PerformanceDetailTableComponent) {
    this.component.type = 'fss';
  }
}
